import Api from '../../services';
import StorageService from '../../storage-service';
import { getUser } from './user.actions';

export const login = (data) => {
  return (dispatch) => {
    return Api.auth.login(data).then((response) => {
      dispatch({
        type: 'LOGIN',
        data: response,
      });
      dispatch({
        type: 'SET_META_DATA',
        data: response,
      });
      return response;
    });
  };
};

export const loginWithPhoneNumber = (data) => {
  return (dispatch) => {
    return Api.auth.login(data).then((response) => {
      dispatch({
        type: 'LOGIN_WITH_PHONE_NUMBER',
        data: response,
      });
      return response;
    });
  };
};

export const confirmMobileOtp = (otp, code) => {
  return (dispatch) => {
    return Api.auth.confirmOtp(otp, code).then((response) => {
      dispatch({ type: 'CONFIRM_MOBILE_OTP', data: response });
      return response;
    });
  };
};

export const confirmOtp = (otp, code) => {
  return (dispatch) => {
    return Api.auth.confirmOtp(otp, code).then((response) => {
      dispatch({
        type: 'CONFIRM_OTP',
        data: response,
      });
      dispatch(getUser());
      return response;
    });
  };
};

export const signUp = (data) => {
  return (dispatch) => {
    return Api.auth.signUp(data).then((response) => {
      dispatch({
        type: 'SIGN_UP',
        data: response,
      });
      dispatch({
        type: 'SET_META_DATA',
        data: response,
      });
      return response;
    });
  };
};

export const logout = () => {
  return (dispatch) => {
    return Api.auth.logout().then((response) => {
      dispatch({ type: 'LOGOUT' });
      return response;
    });
  };
};

export const checkAuth = () => {
  return async (dispatch) => {
    const token = await StorageService.get('api_token');
    dispatch({ type: 'CHECK_AUTH', data: token !== null });
    return token !== null;
  };
};

export const checkCompleteProfile = () => {
  return async (dispatch) => {
    const missingKeys = await StorageService.get('missing_keys');
    dispatch({ type: 'CHECK_COMPLETE_PROFILE', data: missingKeys });
    return missingKeys;
  };
};

export const resendOtp = (otp) => {
  return (dispatch) => {
    return Api.auth.resendOtp(otp).then((response) => {
      dispatch({ type: 'RESEND_OTP' });
      return response;
    });
  };
};

export const forgetPassword = (data) => {
  return (dispatch) => {
    return Api.auth.forgetPassword(data).then((response) => {
      dispatch({
        type: 'FORGET_PASSWORD',
        data: response,
      });
      return response;
    });
  };
};

export const verifyOtp = (data) => {
  return (dispatch) => {
    return Api.auth.verifyOtp(data).then((response) => {
      dispatch({
        type: 'VERIFY_OTP',
        data: response,
      });
      return response;
    });
  };
};

export const resetPassword = (data) => {
  return (dispatch) => {
    return Api.auth.resetPassword(data).then((response) => {
      dispatch({
        type: 'RESET_PASSWORD',
        data: response,
      });
      return response;
    });
  };
};
